import { IFilterDefinition } from '@df/catalog-ui/listing/listing';
import { ProductListing } from '@df/catalog-ui/listing/product-listing';
import { IProductDataV2, Product } from '@df/catalog/product/product';
import { NgInject } from '@df/ng/ng-inject';
import { InternalProductsService } from './../product/internal-products.service';
import { IN_STOCK_FILTER_ID } from './filter/stock/filter-stock';

export class ProductListingDecorator<T extends Product = Product<IProductDataV2>> extends ProductListing<T> {
    @NgInject(InternalProductsService)
    private internalProductsService!: InternalProductsService;

    override onInit(): void {
        super.onInit();

        this.subscriptions.add(
            this.internalProductsService.update.subscribe(() => {
                const currentLength = this.modelsBare?.length;

                this.setSourceModels(this.initModels);

                if (currentLength !== this.modelsBare?.length) {
                    this.apply();
                }
            })
        );
    }

    override updateLimits() {
        const models = this.modelsFiltered;

        if (models && !this.config.noLimitReset) {
            this.initialLimit = Math.min(models.length, 100);

            // reduce limit if less models visible now
            if (this.limit) {
                this.limit = Math.min(models.length, Math.max(this.initialLimit, this.limit));
            }
        }
    }

    override setSourceModels(models: T[]): this {
        super.setSourceModels(models);

        this.modelsBare = this.internalProductsService.filterProducts(this.modelsBare) as T[];

        return this;
    }

    protected override createFilter(filterDef: IFilterDefinition): void {
        if (filterDef.source === IN_STOCK_FILTER_ID) {
            filterDef.type = 'stock';
        }

        super.createFilter(filterDef);
    }
}
